import { render, staticRenderFns } from "./NotificationAppointmentRejected.vue?vue&type=template&id=a4854664&scoped=true&"
import script from "./NotificationAppointmentRejected.vue?vue&type=script&lang=ts&"
export * from "./NotificationAppointmentRejected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4854664",
  null
  
)

export default component.exports